import { action } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";

/**
 * Action dispatched when shared mailboxes have been loaded from cache
 * This triggers a background network refresh to update the cache
 */
export interface REFRESH_OTHER_MAILBOX_CONFIG_CACHEActionMessage {
    mailboxInfo: MailboxInfo;
}

export const refreshOtherMailboxConfigCache: (mailboxInfo: MailboxInfo) => REFRESH_OTHER_MAILBOX_CONFIG_CACHEActionMessage = action("REFRESH_OTHER_MAILBOX_CONFIG_CACHE", (mailboxInfo: MailboxInfo): REFRESH_OTHER_MAILBOX_CONFIG_CACHEActionMessage => ({
    mailboxInfo,
}));
